export default [
    {
        path: 'consultorias/gestion-entregable-consultor',
        name: 'gestion-entregable-consultor',
        component: () => import('../gestion-entregable-empleado/views/GestionEntregableConsultor.vue'),
    },
    {
        path: 'consultorias/gestion-empleado/:id',
        name: 'consultorias-gestion-empleado',
        component: () => import('../gestion-entregable-empleado/views/index.vue'),
    },
    {
        path: 'consultorias/registro-actividades/:id',
        name: 'consultorias-registro-actividades',
        component: () => import('../gestion-entregable-empleado/views/registroActividades.vue'),
    }
]